import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { userListDataSevice } from '../../_services/Analyze/userList.service';

export const userListAction = {
    userListDataAction
}

function userListDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        userListDataSevice.userListData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_USER_LIST } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_USER_LIST, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_USER_LIST, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/userList.action.js